import PaymentResult from "../../components/Payment/PaymentResult/PaymentResult";

const StatusSuccess = () => {
    return <PaymentResult response="success" />;
};

export default StatusSuccess;
